export default __webpack_public_path__ + "static/InterDisplay-LightItalic-e1fb1293dcc6cc01b1f9d4930bd3262d.woff2";